/**
 * The weather of each biome (ADR 0093): rain on the meadow and the forest,
 * fog on the swamp, blizzards on the snow, sandstorms on the desert. Seen
 * only: it changes nothing of a fight. Computed from the clock like the day
 * and the night, never stored: data here, the pure rule in `rules/weather.ts`.
 */
export const WEATHER_KINDS = ['rain', 'fog', 'blizzard', 'sandstorm'];
const MINUTE_MS = 60_000;
export const BIOME_WEATHER = Object.freeze({
    meadow: {
        kind: 'rain',
        everyMs: 45 * MINUTE_MS,
        lastsMs: 8 * MINUTE_MS,
        chance: 0.5,
        offsetMs: 0,
    },
    forest: {
        kind: 'rain',
        everyMs: 40 * MINUTE_MS,
        lastsMs: 12 * MINUTE_MS,
        chance: 0.6,
        offsetMs: 17 * MINUTE_MS,
    },
    swamp: {
        kind: 'fog',
        everyMs: 35 * MINUTE_MS,
        lastsMs: 15 * MINUTE_MS,
        chance: 0.7,
        offsetMs: 9 * MINUTE_MS,
    },
    snow: {
        kind: 'blizzard',
        everyMs: 50 * MINUTE_MS,
        lastsMs: 8 * MINUTE_MS,
        chance: 0.5,
        offsetMs: 31 * MINUTE_MS,
    },
    desert: {
        kind: 'sandstorm',
        everyMs: 60 * MINUTE_MS,
        lastsMs: 6 * MINUTE_MS,
        chance: 0.4,
        offsetMs: 23 * MINUTE_MS,
    },
});
/** A spell rises and falls over this long, by `WEATHER_STEPS`: it never snaps on. */
export const WEATHER_RAMP_MS = 30_000;
//# sourceMappingURL=weather.js.map